var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGaraje = function SvgGaraje(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3 4a.7.7 0 0 1 .7-.7h20a.7.7 0 0 1 .7.7v2.5a.7.7 0 1 1-1.4 0V4.7H2.7v1.8a.7.7 0 1 1-1.4 0V4Zm4.955 3.75a.7.7 0 0 1 .654-.45h10.182a.7.7 0 0 1 .654.45l1.737 4.55H20a.7.7 0 0 1 .7.7v5a.7.7 0 0 1-.7.7h-2.046A.99.99 0 0 1 18 19v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1a.99.99 0 0 1 .046-.3H9.954A1 1 0 0 1 10 19v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1a1 1 0 0 1 .046-.3H4a.7.7 0 0 1-.7-.7v-5a.7.7 0 0 1 .7-.7h.518l1.737-4.55ZM4.984 13.7H19.3v3.6H4.7v-3.6h.284Zm13-1.4H6.016L7.39 8.7h9.218l1.374 3.6Z",
    fill: "currentColor"
  })));
};
export default SvgGaraje;